export const PATH_COUPON_INDEX = '/aktywacja';
export const PATH_COUPON_ACTIVATE = '/coupon/access-code';
